<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد رزرو
        </b-button>
      </b-col>
    </b-row>
    <div v-if="transactions">
      <div class="d-flex justify-content-between align-items-center">
        <per-page v-model="perPage" class="w-50" />
      </div>
      <b-row>
        <!--        <b-col sm="6" md="3" lg="2">
                  <per-page v-model="perPage" class="w-100" />
                </b-col>-->
        <b-col sm="12" md="12" lg="12">
          <search-reservations
              @searchBase="searchBase"
              :selectedFilter="selectedFilter"
              :submitLoading="searchBasesubmitLoading"
              :isSearchResult="isSearchResult"
              ref="ownersSearchComponent"
              class="w-100"
              v-model="searchInput"
          />
        </b-col>
      </b-row>

      <b-card body-class="p-0" class="mt-1">
        <table-head
            ref="transactionsTableHeadComponent"
            :items="tableHeadings"
            @sort="sort"
        />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="transaction in transactions"
            :key="transaction.id"
        >
          <b-col
              class="d-flex align-items-center pl-0"
              v-if="transaction.order.residence"
          >
           {{transaction.id}}

          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <router-link
                :to="{
                name: 'calender',
                params: { id: transaction.order.residence.id },
              }"
                variant="flat-secondary"
                class="font-weight-bolder btn"
            >
              <BIconCalendar />
            </router-link>
            <b-badge variant="info">
              {{ transaction.order.residence.code }}
            </b-badge>
            <!--            <img :src="$http.defaults.fileUrl+'/'+transaction.order.residence.images[0].path.original" alt="" style="width: 50px;height: 50px">-->
            <a
                target="_blank"
                :href="
                'https://roomtoor.com/space/' +
                transaction.order.residence.category.slug +
                '-' +
                transaction.order.residence.code
              "
            >
              {{ transaction.order.residence.name }}
            </a>
          </b-col>
          <b-col
              class="d-flex align-items-center pl-0"
              v-if="transaction.order.residence.host.full_name"
          >


            <div>
              <span>
                 {{ transaction.order.residence.host.full_name }}
              </span>
              <br/>
              <b-badge variant="primary" v-if="transaction.order.residence.host.mobile">
                {{  transaction.order.residence.host.mobile.replace("+98","0") }}
              </b-badge>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <div>
              <span> {{ transaction.user.full_name }}</span>

              <br />
              <b-badge variant="primary" style="direction: ltr">
                {{ transaction.user.mobile.replace("+98", "0") }}
              </b-badge>
            </div>
          </b-col>
          <b-col
              class="d-flex align-items-center pl-0"
              v-if="transaction.order"
          >
            <div>
              <span>تاریخ ورود : </span>
              <b-badge variant="info" v-if="transaction.order.checkin">
                {{
                  new Date(transaction.order.checkin)
                      .toLocaleString("fa-IR")
                      .split(",")[0]
                }}
              </b-badge>
              <br />
              <span>تاریخ خروج : </span>
              <b-badge variant="info" v-if="transaction.order.checkout">
                {{
                  new Date(transaction.order.checkout)
                      .toLocaleString("fa-IR")
                      .split(",")[0]
                }}
              </b-badge>
              <br />
              <span>تعداد شب : </span>
              <b-badge variant="info" v-if="transaction.order.checkout">
                {{ transaction.order.duration }} شب
              </b-badge>
              <br />
              <span>تعداد مهمان ها در خواست سفارش : </span>
              <b-badge variant="info" v-if="transaction.order.guests.adult>0">
                {{ transaction.order.guests.adult }} نفر بزرگسال
              </b-badge>
              <b-badge
                  variant="info"
                  style="margin: 0 2px"
                  v-if="transaction.order.guests.child>0"
              >
                {{ transaction.order.guests.child }} نفر کودک
              </b-badge>
              <b-badge variant="info" v-if="transaction.order.guests.baby>0">
                {{ transaction.order.guests.baby }} نفر نوزاد
              </b-badge>
              <b-badge
                  variant="info"
                  style="margin: 0 2px"
                  v-if="transaction.order.guests.pet>0"
              >
                {{ transaction.order.guests.pet }} حیوان
              </b-badge>
              <br />
              <span v-if="transaction.price_type==='prepayment'">
                    <span>تعداد مهمان ها در پیش پرداخت : </span>
              <b-badge variant="info" v-if="transaction.prices.guests >0">
                {{ transaction.prices.guests }} نفر
              </b-badge>
              </span>
            </div>
          </b-col>

          <b-col
              class="d-flex align-items-center pl-0"
              v-if="transaction.order"
          >
            <div v-if="transaction.order.prices">
              <span>مجموع هزینه خدمات : </span>
              <b-badge variant="dark" v-if="transaction.order.prices">
                {{ numberFormat(transaction.order.prices.service_price) }} تومان
              </b-badge>
              <br />
              <span>هزینه نوزاد : </span>
              <b-badge variant="dark">
                <span v-if="transaction.order.prices.baby_price > 0">
                  {{ numberFormat(transaction.order.prices.baby_price) }} تومان
                </span>
                <span v-else> 0 </span>
              </b-badge>
              <br />
              <span>هزینه حیوان : </span>
              <b-badge variant="dark">
                <span v-if="transaction.order.prices.pet_price > 0">
                  {{ numberFormat(transaction.order.prices.pet_price) }} تومان
                </span>
                <span v-else> 0 </span>
              </b-badge>
              <br />
              <span v-if="transaction.price_type==='full_payment'">
                    <span>مجموع پرداختی : </span>
                    <b-badge variant="dark" v-if="transaction.paid">
                      <!--                {{  formatnumber(transaction.paid)}} تومان-->
                      {{ numberFormat(transaction.paid) }} تومان
                    </b-badge>
                    <br />
                    <span>کمیسیون سایت  : </span>
                    <b-badge variant="dark" v-if="transaction.order.prices.total_commission_site_roomtoor">
                      <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                      {{ numberFormat(transaction.order.prices.total_commission_site_roomtoor) }} تومان
                    </b-badge>
                    <br />
                    <span>کمیسیون دریافتی میزبان  : </span>
                    <b-badge variant="dark" v-if="transaction.order.prices.total_commission_host">
                      <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                      {{ numberFormat(transaction.order.prices.total_commission_host) }} تومان
                    </b-badge>
              </span>
              <span v-if="transaction.price_type==='prepayment'">
                    <span>مجموع پرداختی کارت به کارت : </span>
                    <b-badge variant="dark" v-if="transaction.paid">
                      <!--                {{  formatnumber(transaction.paid)}} تومان-->
                      {{ numberFormat(transaction.paid) }} تومان
                    </b-badge>
                    <br />
                    <span>کمیسیون سایت  : </span>
                    <b-badge variant="dark" v-if="transaction.prices.commission_site > 0">
                      <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                      {{ numberFormat((transaction.paid * transaction.prices.commission_site)/100) }} تومان
                    </b-badge>
                    <br />
                    <span>کمیسیون دریافتی میزبان  : </span>
                    <b-badge variant="dark" v-if="transaction.prices.commission_site > 0">
                      <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                     {{ numberFormat(transaction.paid - (transaction.paid * transaction.prices.commission_site)/100) }} تومان
                    </b-badge>
              </span>
            </div>
          </b-col>

          <b-col
              class="d-flex align-items-center"
              v-if="transaction.service_type"
          >
            <b-badge
                variant="success"
                class="badge-glow"
                v-if="transaction.service_type === 'manual'"
            >
              پرداخت در محل
            </b-badge>
            <b-badge
                variant="success"
                class="badge-glow"
                v-if="transaction.service_type === 'gateway'"
            >
              آنلاین
            </b-badge>
            <b-badge
                variant="success"
                class="badge-glow"
                v-if="transaction.service_type === 'card'"
            >
              کارت به کارت
            </b-badge>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <b-badge
                variant="success"
                class="badge-glow"
                v-if="transaction.status === 'success'"
            >
              پرداخت موفق
            </b-badge>
            <b-badge
                variant="danger"
                class="badge-glow"
                v-if="transaction.status === 'fail'"
            >
              پرداخت ناموفق
            </b-badge>
            <div v-if="transaction.status === 'pending'">
              <b-badge
                  variant="warning"
                  class="badge-glow mt-1"
                  v-if="transaction.status === 'pending'"
              >
                اومده خرید
              </b-badge>
              <b-badge
                  variant="warning"
                  class="badge-glow mt-1"
                  v-if="transaction.status === 'pending'"
              >
                اومده تست کنه
              </b-badge>
              <b-badge
                  variant="warning"
                  class="badge-glow mt-1"
                  v-if="transaction.status === 'pending'"
              >
                منتظر تایید میزبانه
              </b-badge>
            </div>
          </b-col>
          <b-col
              class="d-flex align-items-center flex-row-reverse"
              style="direction: ltr"
          >
            {{
              new Date(transaction.created_at).toLocaleString("fa-IR", {
                timeZone: "Iran",
              })
            }}
          </b-col>
          <b-col class="d-flex align-items-center">
<!--            <b-button
                variant="flat-info"
                v-if="transaction.status === 'success'"
                class="font-weight-bolder"
                @click="showFormModal(transaction, 'document')"
            >
              <BIconFiles font-scale="1" />
            </b-button>-->
            <b-button
                variant="flat-info"
                class="font-weight-bolder"
                @click="showFormModal(transaction, 'document')"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
            <b-button @click="copyInfo(transaction)" variant="primary">
              کپی
            </b-button>

            <b-button variant="flat-info" class="font-weight-bolder">
              <feather-icon icon="EyeIcon" size="20" />
            </b-button>
            <b-button
                @click="showConfirmModal(transaction)"
                variant="flat-danger"
                class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <!--            <b-button
                            @click="showFormModal(transaction)"
                            variant="flat-secondary"
                            class="font-weight-bolder"
                        >
                          <feather-icon icon="Edit2Icon" size="20" />
                        </b-button>-->
          </b-col>
        </b-row>
      </b-card>
      <pagination
          ref="transactionsPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="650px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div v-if="formType == 'document'" class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{
                editMode
                    ? "ویرایش سند تسویه حساب با میزبان"
                    : "ایجاد سند تسویه حساب با میزبان"
              }}
            </h3>
          </div>
          <div v-else class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش رزرو" : "ایجاد رزرو" }}
            </h3>
          </div>
        </div>
      </template>

      <b-container v-if="formType == 'document'" class="">

        <b-form-group>
          <div>
            <strong>  success :</strong>
            وضعیتی که پرداخت موفق آمیز بوده
          </div>
          <div>
            <strong>  fail :</strong>
              حالتی که تراکنش ناموفق (رفته درگاه انصراف زده) حالت کنسلی
          </div>
          <div>
            <strong>  pending :</strong>
            حالتی که در انتظار پرداخت است
          </div>
          <label for="residence_area" class="text-capitalize">
            وضعیت پرداخت:<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="documentInput.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusPayment"
          />
        </b-form-group>



        <!--        <b-form-group>
                  <label for="document_name" class="text-capitalize"
                  >{{ $t("document_name") }}:</label
                  >
                  <b-form-input
                      id="document_name"
                      v-model="documentInput.name"
                      type="text"
                  />
                </b-form-group>-->
        <!--        <b-form-group>
                  <label for="document_pric" class="text-capitalize"
                  >{{ $t("document_pric") }}:</label
                  >
                  <b-form-input
                      id="document_pric"
                      v-model="documentInput.price"
                      type="text"
                  />
                </b-form-group>-->
        <!--        <b-form-group>
                  <label for="bank_tracking_code" class="text-capitalize"
                  >{{ $t("bank_tracking_code") }}:</label
                  >
                  <b-form-input
                      id="bank_tracking_code"
                      v-model="documentInput.bank_tracking_number"
                      type="text"
                  />
                </b-form-group>-->
        <b-form-group>
          <label for="description" class="text-capitalize"
          >
           توضیحات بیشتر در مورد کنسلی یا جابجایی که مورد قیمت می باشد .(حتما با ذکر علت بیان شود تا میزبان در جریان باشد !)
            <span class="font-weight-bold">اجباری</span>
          </label
          >
          <b-form-input
              id="description"
              v-model="documentInput.description"
              type="text"
          />
        </b-form-group>


        <b-form-group>
          <label for="return_price_host" class="text-capitalize"
          >مبلغ عودتی به میزبان :</label
          >
          <b-form-input
              id="return_price_host"
              v-model="documentInput.return_price_host"
              type="number"
          />
          {{numberFormat(documentInput.return_price_host)}}
          تومان
        </b-form-group>

        <b-form-group>
          <label for="bank_tracking_code" class="text-capitalize"
          >مبلغ عودتی به مهمان :</label
          >
          <b-form-input
              id="bank_tracking_code"
              v-model="documentInput.return_price_guest"
              type="number"
          />
          {{numberFormat(documentInput.return_price_guest)}}
          تومان
        </b-form-group>


        <!--        <label for="document_medias" class="text-capitalize mb-3"
                >{{ $t("document_medias") }}:</label
                >
                <div
                    v-for="(file, index) in documentInput.medias"
                    :key="'file_' + index"
                    class="w-100 d-flex"
                >
                  <b-form-file
                      accept=".zip,.rar,.7zip"
                      v-model="documentInput.medias[index]"
                      ref="file-input"
                  ></b-form-file>
                  &lt;!&ndash; <b-button variant="flat-danger"   @click="removeFile(index)"> <feather-icon icon="Trash2Icon" size="20" /></b-button> &ndash;&gt;
                </div>
                <b-button v-if="documentInput.mediaPath" block mt-2 variant="outline-primary">دانلود اسناد بارگذاری شده</b-button>-->
        <!-- <b-button @click="addNewFile" >افزودن سند دیگر</b-button> -->

        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </b-container>

      <b-container v-else class="">
        <b-form-group>
          <label for="admin_user" class="text-capitalize">* انتخاب  مهمان (مهمان هایی که قبلا درخواست رزرو داشتن) :</label>
          <!--          <v-select
                        id="owner_user"
                        :components="{ OpenIndicator }"
                        class="bg-white"
                        :clearable="false"
                        v-model="orderRequestInput.user_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :get-option-label="(option) => option.full_name"
                        :reduce="(user) => user.id"
                        :options="users"

                        placeholder="برای جستجو تایپ کنید"
                    >
                      <template #option="{ full_name, mobile }">
                        {{ full_name }}
                        <br />
                        <cite>{{ mobile }}</cite>
                      </template>
                    </v-select>-->
          <v-select
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="orderRequestInput.user_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.user_name"
              :reduce="(residence) => residence.user_id"
              :options="orders"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ user_name,id,prices,guests }" style="direction: ltr">
              <cite>
                {{user_name}}
                <br/>
                تعداد :
                {{guests.adult}} بزرگسال -
                {{guests.child}} کودک
              </cite>

            </template>
          </v-select>
        </b-form-group>

        <b-form-group>
          <label for="admin_user" class="text-capitalize">* انتخاب درخواست رزرو برای مهمان انتخاب شده  :</label>
          <v-select
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="orderRequestInput.order_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.user_name+' - '+numberFormat(option.prices.final_price)"
              :reduce="(residence) => residence.id"
              :options="orders"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ user_name,id,service_name,prices,service_host }" style="direction: ltr">
              <cite>
                {{user_name}}
                - {{numberFormat(prices.final_price)}} تومان
                <br/>
                <span>
                  {{service_name}} -
                  {{service_host}}
                </span>
              </cite>

            </template>
          </v-select>
        </b-form-group>


        <b-form-group>
          <b-form-radio
              v-model="orderRequestInput.price_type"
              name="some-radios3"
              value="full_payment"
          >پرداخت کامل </b-form-radio
          >
          <b-form-radio
              v-model="orderRequestInput.price_type"
              name="some-radios3"
              value="prepayment"
          >پیش پرداخت </b-form-radio
          >
        </b-form-group>

        <b-form-group class="mt-3" v-if="orderRequestInput.price_type !== 'prepayment'">
          <label for="transaction_name" class="text-capitalize"
          > مبلغ پرداختی  :</label
          >
          <b-form-input
              id="transaction_name"
              v-model="orderRequestInput.paid"
              type="text"
          />
          <div>
            {{numberFormat(orderRequestInput.paid)}}
          </div>
        </b-form-group>

        <div v-if="orderRequestInput.price_type !== 'full_payment'">
          <b-form-group class="mt-3" >
            <label for="transaction_name" class="text-capitalize"
            > مبلغ فاکتور نهایی که باید به میزبان پرداخت گردد :</label
            >
            <b-form-input
                id="transaction_name"
                v-model="orderRequestInput.paid"
                type="text"
            />
            <div>
              {{numberFormat(orderRequestInput.paid)}}
            </div>
          </b-form-group>

          <b-form-group>
            <label for="adult" class="text-capitalize"
            > هزینه واریزی به سایت : <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.pay_site"
                id="adult"
                key="adult"
                placeholder=" هزینه واریزی به سایت"
            />
            <div>
              {{numberFormat(orderRequestInput.prices.pay_site)}}
            </div>
          </b-form-group>
          <b-form-group>
            <label for="child" class="text-capitalize"
            > هزینه پرداخت در محل یا به میزبان یا واریز به سایت :<span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.pay_area"
                id="child"
                key="child"
                placeholder="  هزینه پرداخت در محل "
            />
            <div>
              {{numberFormat(orderRequestInput.prices.pay_area)}}
            </div>
          </b-form-group>
          <b-form-group>
            <label for="baby" class="text-capitalize"
            > کمیسیون سایت (درصد) <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.commission_site"
                id="baby"
                key="baby"
                placeholder="  کمیسیون بازاریاب"
            />
          </b-form-group>
          <b-form-group>
            <label for="baby" class="text-capitalize"
            > کمیسیون بازاریاب (درصد) <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.visitor"
                id="baby"
                key="baby"
                placeholder="  کمیسیون بازاریاب"
            />
          </b-form-group>
          <b-form-group>
            <label for="adult" class="text-capitalize"
            > تعداد کل نفرات <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.guests"
                id="adult"
                key="adult"
                placeholder="  تعداد کل نفرات "
            />
          </b-form-group>

          <b-form-group>
            <label for="adult" class="text-capitalize"
            > تعداد واحدهای انتخابی <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                type="number"
                v-model="orderRequestInput.prices.unit"
                id="adult"
                key="adult"
                placeholder=" تعداد واحد "
            />
          </b-form-group>
        </div>


        <b-form-group >
          <label for="adult" class="text-capitalize"
          > توضیح مختصر در مورد تراکنش: <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              type="text"
              v-model="orderRequestInput.description"
              id="adult"
              key="adult"
              placeholder=" توضیح مختصر "
          />
        </b-form-group>
        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            وضعیت پرداخت : گزینه success را انتخاب نمایید.<span class="text-danger">*</span>

          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="orderRequestInput.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusPayment"
          />
        </b-form-group>

        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            نوع پرداخت : کارت به کارت .<span class="text-danger">*</span>
          </label>
          <div>
            <div><strong> card :  </strong> کارت به کارت </div>
            <div><strong> gateway :  </strong> درگاه پرداخت </div>
            <div><strong> manual :  </strong> دستی پول نقد </div>
          </div>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="orderRequestInput.service_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="typePayment"
          />
        </b-form-group>

        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            انتخاب کارت بانکی :<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="orderRequestInput.bank_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="cardBank"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> ارسالsms تاییده : </label>
          <b-form-checkbox
              v-model="orderRequestInput.sms"
              :aria-describedby="ariaDescribedby"
              value="yes"

          >بله</b-form-checkbox
          >
        </b-form-group>
<!--        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> ارسال تاییده sms واریزی : </label>
          <b-form-checkbox
              v-model="orderRequestInput.sms"
              :aria-describedby="ariaDescribedby"
              value="yes"

          >بله</b-form-checkbox
          >
        </b-form-group>-->



        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitTransactionForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>

      </b-container>


    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
  BBadge,
  BIconCalendar,
  BIconFiles,
  BFormFile, BFormCheckbox,
} from "bootstrap-vue";
import debounce from 'lodash/debounce';
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import SearchReservations from "@/components/SearchReservations.vue";

export default {
  components: {
    BFormCheckbox,
    SearchReservations,
    BIconCalendar,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    BIconFiles,
    VueUploadMultipleImage,
    BFormFile,
  },
  data() {
    return {
      isSearchResult:false,
      selectedFilter:[],
      formType: "document",
      perPage: 10,
      page: 1,
      transactions: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      users: [],
      residences: [],
      statusPayment:[
        "success",
        "fail",
        "pending",
      ],
      typePayment: [
        "manual",
        "gateway",
        "card"
      ],

      cardBank: [
        "بانک صادرات ",
        "بانک پاسارگارد",
        "سایر بانک ها",
      ],
      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      orders:[],

      transactionInput: {
        name: "",
        slug: "",
        status: "active",
      },
      orderRequestInput:{
        id:"",
        user_id: "",
        order_id: "",
        paid:"",
        status:"",
        service_type:"",
        sms:"",
        bank_type:"",
        price_type:"full_payment",
        prices: {
          pay_site:0,
          pay_area:0,
          visitor:0,
          commission_site:0,
          commission_host:0,
          guests:0,
          unit:0,
        },
        description:"",
      },
      documentInput: {
        status: "",
        user_id: "",
        order_id: "",
        name: "",
        price: "",
        return_price_guest: "",
        return_price_host: "",
        bank_tracking_number: "",
        description: "",
        medias: [[]],
      },
      editMode: false,
      formModal: false,
      submitLoading: false,

      tableHeadings: [
        {
          title: "کد رزرو",
          slug: "code",
          sortable: true,
        },
        {
          title: " عنوان ",
          slug: "title",
          sortable: true,
        },
        {
          title: " میزبان ",
          slug: "host",
          sortable: true,
        },
        {
          title: " مهمان ",
          slug: "guest",
          sortable: true,
        },
        {
          title: " سفارش ",
          slug: "order",
          sortable: true,
        },
        {
          title: " هزینه ",
          slug: "price",
          sortable: true,
        },
        {
          title: " نوع پرداخت ",
          slug: "service_type",
          sortable: true,
        },
        {
          title: " وضعیت ",
          slug: "created_at",
          sortable: true,
        },
        {
          title: " تاریخ درخواست ",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getReservations();
    // this.getCompanies();
    this.getUrlParams();

    this.getUsers();
    this.getOrders();


  },

  created() {
    // Create a debounced version of the search handler
    this.debouncedGetReservations = debounce(this.getReservations, 500);
  },

  watch: {
/*    searchInput(value) {
      this.page = 1;
      this.getReservations();
    },*/
    searchInput(value) {
      this.page = 1; // Reset the page to the beginning
      if (value.trim().length) { // Ensure there is actual input to search for
        this.debouncedGetReservations();
      }
    },
    perPage(value) {
      this.page = 1;
      this.getReservations();
    },
    page(value) {
      this.getReservations();
    },
  },
  methods: {
    copyInfo(transaction) {
      // Format the information
      const info = `تسویه حساب اقامت

تاریخ ورود: ${this.formatDate(transaction?.order?.checkin)}
تاریخ خروج: ${this.formatDate(transaction?.order?.checkout)}
کد محصول: ${transaction?.order?.residence?.code}
عنوان: ${transaction?.order?.residence?.name}
میزبان: ${transaction?.order?.residence?.host?.full_name} شماره تماس: ${transaction?.order?.residence?.host?.mobile?.replace("+98", "0")}
مهمان: ${transaction?.user?.full_name} شماره تماس: ${transaction?.user?.mobile?.replace("+98", "0")}
تعداد شب: ${transaction?.order?.duration} تعداد مهمان: ${transaction?.order?.guests?.adult}
نحوه پرداخت: ${transaction?.service_type === 'gateway' ? 'سایت' : 'پرداخت در محل'}
در تاریخ: ${this.formatDate(transaction?.created_at)}
فاکتور: ${this.numberFormat((transaction?.paid)*10)}
مبلغ پرداختی: ${this.numberFormat((transaction?.paid)*10)}
پرداخت در محل: ${transaction?.service_type === 'manual' ? this.numberFormat((transaction?.paid)*10) : '0'}
پرداختی میزبان به سایت: ${this.numberFormat((transaction?.order?.prices?.total_commission_site_roomtoor)*10)}
تسویه با میزبان: ${this.numberFormat((transaction?.order?.prices?.total_commission_host)*10)}
کمیسیون سایت: ${this.numberFormat((transaction?.order?.prices?.total_commission_site_roomtoor)*10)}
کد رزرو: ${transaction?.id}`;

      // Create a temporary textarea element
      const tempTextarea = document.createElement('textarea');
      tempTextarea.value = info;

      // Append the textarea to the document body
      document.body.appendChild(tempTextarea);

      // Select the text in the textarea
      tempTextarea.select();

      // Copy the selected text to the clipboard
      document.execCommand('copy');

      // Remove the temporary textarea from the document body
      document.body.removeChild(tempTextarea);

      // Optionally, show a success message or perform any other actions
      this.$bvToast.toast('عزیزم کپی با موقعیت انجام شد !', {
        title: 'Success',
        variant: 'success',
      });
    },
    formatDate(date) {
      return new Date(date).toLocaleString("fa-IR").split(",")[0];
    },
    numberFormatRial(number) {
      return new Intl.NumberFormat('fa-IR').format(number);
    },
    getOrders(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };
      const requestData = {
        method: "get",
        url: "/admin/all_order?orderable_type=residence",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.orders = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    getUrlParams() {
      if ("filter[service_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[service_name]`];
        this.selectedFilter.push("service_name");
      }
      if ("filter[status]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[status]`];
        this.selectedFilter.push("status");
      }
      if ("filter[id]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[id]`];
        this.selectedFilter.push("id");
      }
      if ("filter[user_mobile]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[user_mobile]`];
        this.selectedFilter.push("user_mobile");
      }
      if ("filter[user_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[user_name]`];
        this.selectedFilter.push("user_name");
      }
      if ("filter[host_mobile]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_mobile]`];
        this.selectedFilter.push("host_mobile");
      }
      if ("filter[host_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_name]`];
        this.selectedFilter.push("host_name");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }

    },

    searchBase(data) {
      this.selectedFilter = data.selectedFilter;

      this.searchInput = data.searchInput;

      this.isSearchResult = this.searchInput !== "" && data.type !== "delete";

      this.searchBasesubmitLoading = true;

      this.getReservations();
    },
/*    searchBase(data) {
      console.log("data", data);
      this.selectedFilter = [];
      if (data.selectedFilter.length > 0) {
        data.selectedFilter.forEach((item) => {
          if (item == "service_name") {
            this.searchInput = data.searchInput;
          } else if (item == "status") {
            this.searchInput = data.searchInput;
          } else if (item == "host_mobile") {
            this.searchInput = data.searchInput;
          }
          else if (item == "host_name") {
            this.searchInput = data.searchInput;
          }
        });
        this.selectedFilter = data.selectedFilter;
      }
      this.searchBasesubmitLoading = true;
      if (this.searchInput) {
        this.isSearchResult = true;
      }
      if (data.type == "delete") {
        this.isSearchResult = false;
      }
      this.getReservations();
    },*/

    addNewFile() {
      this.documentInput.medias.push([]);
    },

    removeFile(index) {
      this.documentInput.medias.splice(index, 1);
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getReservations();
    },

    async getReservations() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        "filter[service_name]": this.selectedFilter.includes("service_name")
            ? this.searchInput
            : "",
        "filter[status]": this.selectedFilter.includes("status")
            ? this.searchInput
            : "",
        "filter[id]": this.selectedFilter.includes("id")
            ? this.searchInput
            : "",
        "filter[user_mobile]": this.selectedFilter.includes("user_mobile")
            ? this.searchInput
            : "",
        "filter[user_name]": this.selectedFilter.includes("user_name")
            ? this.searchInput
            : "",
        "filter[host_mobile]": this.selectedFilter.includes("host_mobile")
            ? this.searchInput
            : "",
        "filter[host_name]": this.selectedFilter.includes("host_name")
            ? this.searchInput
            : "",

        paginate: true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/transactions?per_page=20&filter[orderable_type]=residence",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.transactions = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
    },
    showConfirmModal(transaction) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف رزرو مطمئن هستید ؟" + `: ${transaction.payment_id}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let transactionIndex = 0;
              this.transactions = await this.transactions.filter(
                  (transactionItem, index) => {
                    if (transactionItem.id == transaction.id) {
                      transactionIndex = index;
                    }
                    return transactionItem.id !== transaction.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/transactions/${transaction.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `رزرو: ${transaction.payment_id} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.transactions.splice(transactionIndex, 0, transaction);
                  });
            }
          });
    },
    showFormModal(transaction, type) {
      if (type == "document") {
        this.formType = "document";
        this.editMode = true;
        this.documentInput = {
          name: transaction.document_name,
          price:transaction.document_price,
          bank_tracking_number:transaction.bank_tracking_number,
          description:transaction.description,
          return_price_host:transaction.return_price_host,
          return_price_guest:transaction.return_price_guest,
          status: transaction.status,
          medias: [[]],
          mediaPath:transaction.document_media.path

        };
        this.transactionInput = {
          id: transaction.id,
          name: transaction.name,
          slug: transaction.slug,
          status: transaction.status,
        };
      } else {
        this.formType = "mainTransationInfo";
        if (transaction) {
          this.transactionInput = {
            id: transaction.id,
            name: transaction.name,
            slug: transaction.slug,
            status: transaction.status,
          };
          this.editMode = true;
        } else {
          this.transactionInput = {
            name: "",
            slug: "",
            status: "active",
          };
          this.editMode = false;
        }
      }
      this.formModal = true;
    },
    submitForm() {
      this.submitLoading = true;
      let formData = new FormData();
      if (this.formType == "document") {
        //     formData.append("document_name", this.documentInput.name);
        //     formData.append("document_price", this.documentInput.price);

 /*       formData.append(
            "bank_tracking_number",
            this.documentInput.bank_tracking_number
        );*/
        // formData.append("document_media", this.documentInput.medias[0]);
        formData.append("description", this.documentInput.description);
        formData.append("status", this.documentInput.status);
        formData.append("return_price_guest", this.documentInput.return_price_guest);
        formData.append("return_price_host", this.documentInput.return_price_host);
      }

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/transactions/update/${this.transactionInput.id}`
            : `/admin/transactions`,
         data: this.formType == "document" ? formData : this.transactionInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "رزرو با موفقیت اضافه شد";
            if (this.editMode) message = "رزرو با موفقیت ویرایش شد";
            if(this.formType == 'document')  message = "سند میزبان با موفقیت اضافه شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (
                !this.editMode &&
                this.transactions &&
                this.transactions.length > 0
            ) {
              this.$refs.transactionsPaginationComponent.clear();
              // this.$refs.transactionsSearchComponent.clear();
              this.$refs.transactionsTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getReservations();
          })
          .catch((err) => {
            let message = "خطا در ایجاد رزرو";
            if (this.editMode) message = "خطا در ویرایش رزرو";
            if(this.formType == 'document')  message = "خطا در ایجاد سند";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


    submitTransactionForm() {
      if (this.submitLoading) return;
      /*
            let errorMessage = null;

            if (!errorMessage && !this.orderInput.name) {
              errorMessage = "لطفا نام سفارش را وارد کنید";
            }
            if (!errorMessage && this.orderInput.name.length < 2) {
              errorMessage = "نام سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }
            if (!errorMessage && !this.orderInput.slug) {
              errorMessage = "لطفا اسلاگ سفارش را وارد کنید";
            }
             if (!errorMessage && this.orderInput.slug.length < 2) {
              errorMessage = "اسلاگ سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }


            if (errorMessage) {
              this.$bvToast.toast(errorMessage, {
                title: this.$t("Error"),
                variant: "danger",
                solid: true,
              });
              return;
            }
      */

      this.submitLoading = true;

      const requestData = {
        method: "post",
        url: `/admin/transactions`,
        data: this.orderRequestInput,
      };
      this.$http(requestData)
          .then((response) => {
            let message = "سفارش با موفقیت اضافه شد";
            //  if (this.editMode) message = "سفارش با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            /*     if (!this.editMode && this.orders && this.orders.length > 0) {
                   this.$refs.ordersPaginationComponent.clear();
                   // this.$refs.ordersSearchComponent.clear();
                   this.$refs.ordersTableHeadComponent.clear();
                   this.page = 1;
                   this.searchInput = "";
                   this.sortBy = "";
                   this.sortDir = "";
                 }*/

            this.submitLoading = false;
            this.formModal = false;
            //this.$router.back();
            //this.getReservations();
            window.location.reload();
          })
          .catch((err) => {
            let message = "خطا در ایجاد تراکنش";
            if (this.editMode) message = "خطا در ویرایش تراکنش";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>


